import { type DefaultRootState } from 'react-redux';

export const isProfileReady = (state: DefaultRootState): boolean => Boolean(state.user.my);
